<template>
  <div class="h5-wrap main">
    <h3 class="title">
      {{$store.getters.getCompanyInfo.name}}
    </h3>
    <img class="title-img" src="https://v1-static.oss-cn-zhangjiakou.aliyuncs.com/image/title.png" alt="">
    <div class="link-main">
      <a class="link bg-btn-4" @click="whetherLogin">
        <img src="https://v1-static.oss-cn-zhangjiakou.aliyuncs.com/image/icon1.png" alt="">
        防疫健康打卡</a>
      <a class="link bg-btn-2" href="https://news.qq.com/zt2020/page/feiyan.htm"><img src="https://v1-static.oss-cn-zhangjiakou.aliyuncs.com/image/icon2.png" alt="">疫情动态</a>
      <a class="link bg-btn-3" href="http://2019ncov.nosugartech.com/?scene=2&clicktime=1580254090&enterid=1580254090&from=groupmessage&isappinstalled=0">
      <img src="https://v1-static.oss-cn-zhangjiakou.aliyuncs.com/image/icon3.png" alt="">确诊患者同行程查询</a>
      <a class="link bg-btn-1" href="https://ncov.html5.qq.com/community?channelid=17&from=groupmessage&isappinstalled=&jump_from=F2OB5DIbI_dn1doDSBiPt0eY&seqno=HF1OrJobcH5kFpgy2PGfFrnl">
      <img src="https://v1-static.oss-cn-zhangjiakou.aliyuncs.com/image/icon4.png" alt="">确诊患者小区查询</a>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Index',
  data() {
    return {

    }
  },
  created() {
    let id = this.$route.query.organization_id,
        oldId = this.$store.getters.getCompanyInfo.organization_id;
    if(id) {
      this.organization_id = id;
      if(id !== oldId) {
        localStorage.removeItem('personInfo')
      }
    } else {
      this.organization_id = oldId
    }
    this.getOrganization();
  },
  methods: {
    whetherLogin() {
      const token = localStorage.getItem('UserInfo') === null ? '' : JSON.parse(localStorage.getItem('UserInfo')).token,
            hasPersonInfo = localStorage.getItem('personInfo');
      if(token) {
        if(hasPersonInfo) {
          this.$router.push('/h5/temperature')
        } else {
          this.$router.push('/h5/login')
        }
      } else {
        this.$router.push('/h5/login')
      }
    },
    getOrganization() {
        this.axios.get(`/person/organization?organization_id=${this.organization_id}`).then(r => {
          if(r.data.code === 200){
            let data = r.data.data;
            this.$store.commit('setCompanyInfo', {organization_id: this.organization_id, name: data.name})
          }
        }).catch( err => {
          this.clearTimer()
          console.log(err)
          this.loading = false
        })
      }
  }
}
</script>
<style scoped lang="scss">
.main {
  padding: .4rem .3rem;
  background: url('https://v1-static.oss-cn-zhangjiakou.aliyuncs.com/image/bg.png') no-repeat center top / 100% 100%;
  h3 {
    margin: 0;
    // font-family: "YouSheBiaoTiHei";
    font-weight: bold;
    font-size: .20rem;
    text-align: center;
    font-style: italic;
    color: #fff;
    letter-spacing: 0;
  }
  .title-img {
    width: 100%;
    margin: .15rem 0 .5rem;
  }
  .link {
    height: .9rem;
    margin-bottom: .2rem; 
    padding-left: .32rem;
    font-family: "PingFangSC-Medium";
    font-size: .19rem;
    background-repeat: no-repeat;
    background-size: auto 100%;
    display: flex;
    text-decoration: none;
    align-items: center;
    color: #fff;
    img {
      width: .4rem;
      margin-right: .27rem;
    }
  }
}
.link-main {
  width: 3.1rem;
  margin: 0 auto;
}
.bg-btn-1 {
  background-image: url('https://v1-static.oss-cn-zhangjiakou.aliyuncs.com/image/bg-btn-1.png')
}
.bg-btn-2 {
  background-image: url('https://v1-static.oss-cn-zhangjiakou.aliyuncs.com/image/bg-btn-2.png')
}
.bg-btn-3 {
  background-image: url('https://v1-static.oss-cn-zhangjiakou.aliyuncs.com/image/bg-btn-3.png')
}
.bg-btn-4 {
  background-image: url('https://v1-static.oss-cn-zhangjiakou.aliyuncs.com/image/bg-btn-4.png')
}
</style>